import { render } from "./SideRight.vue?vue&type=template&id=dd7c8202&scoped=true"
import script from "./SideRight.vue?vue&type=script&lang=js"
export * from "./SideRight.vue?vue&type=script&lang=js"

import "./SideRight.vue?vue&type=style&index=0&id=dd7c8202&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd7c8202"]])

export default __exports__